module.exports = __webpack_public_path__ + "static/media/ic_check.f6b02b2c.svg";